import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  IconButton,
  Grid,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';

import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import SelectReact from 'react-select'; 
import i18n from '../../i18n';
import { multipleWeekOptions } from '../../constants/general';

import '../../assets/stylesheets/ScheduleView.css';

class WeekPicker extends Component {
  render() {
    const {
      startOfSelectedWeek,
      onChange,
      multipleWeekValue,
      onSelectMultipleWeeks,
      onSelectPreviousWeek,
      onSelectNextWeek,
      includeWeekend,
      onWeekendClick,
      showWeekendToggle
    } = this.props;

    return (
      <Paper className="blockContainer">
        <Grid container>
          <Grid item xs={2} className="customGridItem">
            <IconButton
              onClick={onSelectPreviousWeek}
              aria-label={i18n.t('schedule:showPreviousWeek')}
            >
              <KeyboardArrowLeft color="secondary" />
            </IconButton>
          </Grid>
          <Grid item xs={8}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                className="weekDatePicker"
                value={startOfSelectedWeek}
                label={i18n.t('schedule:selectWeek')}
                onChange={onChange}
                format="d MMM yyyy"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={2} className="customGridItem">
            <IconButton
              onClick={onSelectNextWeek}
              aria-label={i18n.t('schedule:showNextWeek')}
            >
              <KeyboardArrowRight color="secondary" />
            </IconButton>
          </Grid>
          <Grid item xs={3} />
          <Grid item xs={8}>
            {(typeof showWeekendToggle === 'undefined' || showWeekendToggle) &&
              onWeekendClick && (
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      checked={includeWeekend}
                      onClick={onWeekendClick}
                    />
                  }
                  label={i18n.t('schedule:showWeekend')}
                  labelPlacement="start"
                />
              )}
          </Grid>
          <Grid item xs={1} />
          {onSelectMultipleWeeks &&
          <> 
            <Grid item xs={12}>
              <h4>{i18n.t('availability:numOfWeeks')}</h4>
            </Grid>
            <Grid item xs={12}>
              <SelectReact
                fullWidth
                value={multipleWeekOptions[multipleWeekValue - 1]}
                options={multipleWeekOptions}
                onChange={onSelectMultipleWeeks}
              />
            </Grid>
          </>
          }
        </Grid>
      </Paper>
    );
  }
}

WeekPicker.propTypes = {
  startOfSelectedWeek: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  onSelectPreviousWeek: PropTypes.func.isRequired,
  onSelectNextWeek: PropTypes.func.isRequired,
  includeWeekend: PropTypes.bool.isRequired,
  multipleWeekValue: PropTypes.number,
  onSelectMultipleWeeks: PropTypes.func,
  onWeekendClick: PropTypes.func,
  showWeekendToggle: PropTypes.bool
};

WeekPicker.defaultProps = {
  showWeekendToggle: undefined,
  multipleWeekValue: 1,
  onSelectMultipleWeeks: undefined,
  onWeekendClick: undefined
};

export default WeekPicker;
